import { useCallback, useState } from "react";
import {
  US_STATES,
  getRegionConfig,
  type State,
} from "../utils/country-config";

export default function useCountryStates() {
  const [selectedCountry, setSelectedCountry] = useState<string>("US");
  const [stateOptions, setStateOptions] = useState<State[]>(US_STATES);

  const handleCountryChange = useCallback(
    (
      selectedCountryCode: string,
      fetchStates?: (countryCode: string) => Promise<State[]>,
    ) => {
      setSelectedCountry(selectedCountryCode);
      const fallbackStates = selectedCountryCode === "US" ? US_STATES : [];
      if (fetchStates) {
        fetchStates(selectedCountryCode)
          .then((states) =>
            setStateOptions(states.length > 0 ? states : fallbackStates),
          )
          .catch((error) => {
            console.error("Failed to fetch states:", error);
            setStateOptions(fallbackStates);
          });
      } else if (selectedCountryCode === "US") {
        setStateOptions(US_STATES);
      } else {
        setStateOptions([]);
      }
    },
    [],
  );

  const config = getRegionConfig(selectedCountry);

  return { handleCountryChange, stateOptions, config, selectedCountry };
}
